import { render, staticRenderFns } from "./BlackGoldGames.vue?vue&type=template&id=0d671ad6&"
import script from "./BlackGoldGames.vue?vue&type=script&lang=js&"
export * from "./BlackGoldGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports